<template>
  <div class="table" ref="table">
    <slot></slot>
  </div>
</template>

<script setup>
  import { ref, onMounted, reactive } from 'vue';

  const table = ref(null);
  let tdLength;

  defineProps({
    columns: {
      type: Number,
      default: 4,
    },
  });

  const data = reactive({
    columns: null,
  });

  onMounted(() => {
    const th = table.value.querySelector('.th');
    const td = th.querySelectorAll('.td');
    data.columns = td.length;

    tdLength = data.columns;
  });
</script>

<style lang="scss">
  @import '@sass/global/mixins';
  @import '@sass/global/functions';

  $columns: v-bind('data.columns');

  .table {
    @apply w-full block border-collapse;

    @include media(lg) {
      display: table;
    }

    .th {
      position: relative;
      display: none;
      padding: 0;
      height: 6px;
      margin-bottom: 8px;
      position: sticky;
      top: 80px;
      z-index: 2;

      .td {
        display: none;
      }

      @include media(lg) {
        @apply rounded-lg bg-white;

        display: table-row;
        font-weight: 900;
        color: color(--grey-300);
        box-shadow: 0 0 0 1px rgba(#000, 10%);

        .td {
          display: table-cell;
          padding: 16px 24px;
          text-align: center;

          &:first-of-type {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-of-type {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
      }
    }

    .tr {
      @apply border-b hover:bg-black/5;

      padding: 8px 0;
      display: block;
      background-color: #fff;
      margin-bottom: 16px;

      .td {
        @apply py-2 px-6 block;

        &:last-of-type {
          border-bottom: none;
        }

        &::before {
          content: attr(data-title);
          display: block;
          margin-bottom: 10px;
          min-width: 98px;
          font-size: 10px;
          line-height: 10px;
          font-weight: bold;
          text-transform: uppercase;
          color: color(--grey-200);

          &:last-of-type {
            display: none;
          }
        }

        @include media(lg) {
          display: table-cell;
          text-align: center;
          vertical-align: middle;

          &::before {
            content: attr(data-title);
            display: block;
            margin-bottom: 10px;
            min-width: 98px;
            font-size: 10px;
            line-height: 10px;
            font-weight: bold;
            text-transform: uppercase;
            color: color(--grey-100);
          }
        }
      }

      @include media(lg) {
        display: table-row;
        width: 100%;
        background-color: transparent;
        margin: 0;
        padding: 0;
        box-shadow: none;
        border-top: none;
        color: color(--grey-200);

        .td {
          &::before {
            display: none;
          }
        }
      }
    }

    .btn {
      padding: 12px 16px;
    }
  }
</style>
